import ExcavatorCrane from "../pages/npors/excavatorcrane";
import ExcavatorMicro from "../pages/npors/excavatormicro";
import ForwardTippingDumper from "../pages/npors/forwardtippingdumper";
import ForwardTippingMiniDumper from "../pages/npors/forwardtippingminidumper";
import GritterSnowplough from "../pages/npors/grittersnowplough";
import HarnessFallArrest from "../pages/npors/harnessandfallarrest";
import IndustrialForkliftCourse from "../pages/npors/industrialcounterbalancedforklift";
import LoadingShovelCourse from "../pages/npors/loadingshovel";
import LogHandlerCourse from "../pages/npors/loghandler";
import LorryLoaderCourse from "../pages/npors/lorryloader";
import MEWPBoomCourse from "../pages/npors/mewpboom";
import MEWPScissorCourse from "../pages/npors/mewpscissor";
import PaverCourse from "../pages/npors/paver";
import PlantLoaderSecurer from "../pages/npors/plantloadersecurer";
import PlantMachineryMarshal from "../pages/npors/plantmachinerymarshall";
import PlantMover from "../pages/npors/plantmover";
import RearTippingDumper from "../pages/npors/reartippingdumper";
import QuickHitchAwareness from "../pages/npors/quickhitchawareness";
import RoadPlaner from "../pages/npors/roadplaner";
import RideOnRoller from "../pages/npors/rideonroller";
import RoadSweeper from "../pages/npors/roadsweeper";
import SafeWorkingAtHeight from "../pages/npors/safeworkingatnight";
import SafetyAwareness from "../pages/npors/safetyawareness";
import Screener from "../pages/npors/screener";
import SlingerSignaller from "../pages/npors/slingersignaller";
import TelescopicHandler from "../pages/npors/telescopichandler";
import VehicleMarshal from "../pages/npors/vehiclemarshall";
import MarineKnuckleBoomCrane from "../pages/npors/marineknuckleboom";
import AgriculturalTractor from "../pages/npors/agriculturaltractor";
import CableAvoidance from "../pages/npors/cableavoidance";
import ChainsawAssessment from "../pages/npors/chainsawoperation";
import Crusher from "../pages/npors/crusher";
import Dozer from "../pages/npors/dozer";
import Excavator180 from "../pages/npors/excavator180";
import Excavator360 from "../pages/npors/excavator360";

const nporsRoutes = [
  { path: "/npors-agriculturaltractor", element: <AgriculturalTractor /> },
  { path: "/npors-cableavoidance", element: <CableAvoidance /> },
  { path: "/npors-chainsawoperation", element: <ChainsawAssessment /> },
  { path: "/npors-crusher", element: <Crusher /> },
  { path: "/npors-dozer", element: <Dozer /> },
  { path: "/npors-excavator180", element: <Excavator180 /> },
  { path: "/npors-excavator360", element: <Excavator360 /> },
  { path: "/npors-excavatorcrane", element: <ExcavatorCrane /> },
  { path: "/npors-excavatormicro", element: <ExcavatorMicro /> },
  { path: "/npors-forwardtippingdumper", element: <ForwardTippingDumper /> },
  {
    path: "/npors-forwardtippingminidumper",
    element: <ForwardTippingMiniDumper />,
  },
  { path: "/npors-grittersnowplough", element: <GritterSnowplough /> },
  { path: "/npors-harnessandfallarrest", element: <HarnessFallArrest /> },
  {
    path: "/npors-industrialcounterbalancedforklift",
    element: <IndustrialForkliftCourse />,
  },
  { path: "/npors-loadingshovel", element: <LoadingShovelCourse /> },
  { path: "/npors-loghandler", element: <LogHandlerCourse /> },
  { path: "/npors-lorryloader", element: <LorryLoaderCourse /> },
  { path: "/npors-mewpboom", element: <MEWPBoomCourse /> },
  { path: "/npors-mewpscissor", element: <MEWPScissorCourse /> },
  { path: "/npors-marineknuckleboom", element: <MarineKnuckleBoomCrane /> },
  { path: "/npors-paver", element: <PaverCourse /> },
  { path: "/npors-plantloadersecurer", element: <PlantLoaderSecurer /> },
  { path: "/npors-plantmachinery", element: <PlantMachineryMarshal /> },
  { path: "/npors-plantmover", element: <PlantMover /> },
  { path: "/npors-reartippingdumper", element: <RearTippingDumper /> },
  { path: "/npors-quickhitchawareness", element: <QuickHitchAwareness /> },
  { path: "/npors-roadplaner", element: <RoadPlaner /> },
  { path: "/npors-rideonroller", element: <RideOnRoller /> },
  { path: "/npors-roadsweeper", element: <RoadSweeper /> },
  { path: "/npors-safeworkingatnight", element: <SafeWorkingAtHeight /> },
  { path: "/npors-safetyawareness", element: <SafetyAwareness /> },
  { path: "/npors-screener", element: <Screener /> },
  { path: "/npors-slingersignaller", element: <SlingerSignaller /> },
  { path: "/npors-telescopichandler", element: <TelescopicHandler /> },
  { path: "/npors-vehiclemarshall", element: <VehicleMarshal /> },
];

export default nporsRoutes;
